import { Lock } from 'lucide-react';
import ErrorPage from '@/components/ErrorPage';
import { useAuth } from '@/contexts/AuthContext';
import { AUTH_LOGIN } from '@/constants/constant-routes';

export default function UnauthorizedAccess() {
  const { logout } = useAuth();

  // Always land on login — whether the logout API succeeds or fails
  // (e.g., no token → 401), the session is cleared client-side and we navigate.
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed, redirecting to login anyway:', error);
    } finally {
      window.history.replaceState(null, '', AUTH_LOGIN);
      window.location.replace(AUTH_LOGIN);
    }
  };

  return (
    <ErrorPage
      title="401"
      subtitle="Unauthorized Access"
      description="Your session doesn't grant access to this area. Please sign in again, or contact your administrator if you believe you should have access."
      // No "go back": nothing behind this page is reachable with the session as
      // it stands, so the only honest action is to sign in again.
      primaryButtonText=""
      secondaryButtonText="Logout"
      secondaryButtonIcon={Lock}
      onSecondaryClick={handleLogout}
    />
  );
}
